module.exports = __webpack_public_path__ + "img/SES_140258718.653ad046.jpg";